import type { BodyRouteParamsRequest } from '@pba/utils';
import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { PostContentObjectDetailDataObject } from 'models/service';

type UpdatePost = {
  attachments?: Array<{ id: string }>;
  community_id?: string;
  html_content: string;
  pinned?: boolean;
  publish_at?: string;
  text_content: string;
};

type UpdatePostRequestBody = {
  post: UpdatePost;
};

type UpdatePostRouteParameters = {
  id: string;
};

export const updatePost = async ({
  body,
  routeParams,
}: BodyRouteParamsRequest<UpdatePostRequestBody, UpdatePostRouteParameters>) =>
  apiClient.patch<PostContentObjectDetailDataObject, ApiClientResponse<PostContentObjectDetailDataObject>>(
    routes.posts.update(routeParams.id),
    body,
  );
